import { render } from "./barcodeComponent.vue?vue&type=template&id=c4ca2d38&scoped=true"
import script from "./barcodeComponent.vue?vue&type=script&lang=js"
export * from "./barcodeComponent.vue?vue&type=script&lang=js"

import "./barcodeComponent.vue?vue&type=style&index=0&id=c4ca2d38&scoped=true&lang=css"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4ca2d38"]])

export default __exports__